import styled from "styled-components";

/* ================= PAGE ================= */

export const Page = styled.div`
  background-color: #000;
  min-height: 100vh;
  position: relative;
  overflow: hidden;

  padding-top: 20px;

  @media (max-width: 576px) {
    padding-top: 12px;
  }
`;

/* ================= SEARCH ================= */

export const ContentWrapper = styled.div`
  position: relative;
  z-index: 2;
`;


export const SearchInput = styled.input`
  box-sizing: border-box;

  width: 100%;
  max-width: 320px;

  padding: 10px 14px;

  background: #0d0d0d;
  color: #ffffff;

  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;

  font-size: 14px;

  outline: none;
  transition: all 0.2s ease;

  &::placeholder {
    color: rgba(255, 255, 255, 0.4);
  }

  &:focus {
    border-color: rgba(228, 218, 27, 0.6);
    box-shadow: 0 0 0 2px rgba(228, 218, 27, 0.15);
  }

  /* MOBILE */
  @media (max-width: 576px) {
    max-width: 100%;
    font-size: 13px;
    padding: 9px 12px;
  }
`;

/* ================= VIDEO CARD ================= */

export const VideoCard = styled.div`
  cursor: pointer;
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid rgba(228, 218, 27, 0.18);
  transition: transform 0.25s ease, box-shadow 0.25s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 10px 28px rgba(228, 218, 27, 0.25);
  }

  @media (max-width: 576px) {
    border-radius: 10px;
  }
`;

/* ================= THUMB ================= */

export const Thumb = styled.div`
  position: relative;
  padding-top: 56.25%;
  background: #111;

  iframe {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    border: 0;
    pointer-events: none;
  }
`;

/* ================= TITLE ================= */

export const VideoTitle = styled.h3`
  padding: 10px 12px;
  font-size: 14px;
  font-weight: 600;
  color: #e4da1b;
  line-height: 1.4;

  @media (max-width: 576px) {
    font-size: 13px;
    padding: 8px 10px;
  }
`;

/* ================= PLAYER ================= */

export const PlayerWrapper = styled.div`
  max-width: 900px;
  margin: 0 auto;
  border-radius: 18px;
  overflow: hidden;
  border: 1px solid rgba(228, 218, 27, 0.3);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.6);

  iframe {
    width: 100%;
    height: 500px;
    border: 0;
  }

  @media (max-width: 992px) {
    iframe {
      height: 420px;
    }
  }

  @media (max-width: 768px) {
    border-radius: 14px;

    iframe {
      height: 280px;
    }
  }

  @media (max-width: 576px) {
    iframe {
      height: 220px;
    }
  }
`;

/* ================= BACK BUTTON ================= */

export const BackButton = styled.button`
  background: transparent;
  color: #e4da1b;
  border: 1px solid #e4da1b;

  padding: 9px 16px;
  border-radius: 999px;

  cursor: pointer;
  font-weight: 600;
  font-size: 14px;

  transition: all 0.25s ease;

  &:hover {
    background: #e4da1b;
    color: #000;
  }

  @media (max-width: 576px) {
    font-size: 13px;
    padding: 8px 14px;
  }
`;

/* ================= BG LOGO ================= */

export const BgLogo = styled.img`
  position: absolute;
  top: 120px;
  left: -140px;

  max-width: 70%;
  opacity: 0.06;

  z-index: 0;
  pointer-events: none;
  transform: rotate(-18deg);

  @media (max-width: 992px) {
    max-width: 80%;
    left: -180px;
  }

  @media (max-width: 768px) {
    top: 80px;
    left: -120px;
    max-width: 90%;
    opacity: 0.04;
  }

  @media (max-width: 576px) {
    top: 60px;
    left: -100px;
    max-width: 120%;
    opacity: 0.03;
  }
`;
